var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, merge, cloneDeep } from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import apolloClient from "@irati/utils/services/apollo/client";
import tracking from "@irati/utils/tracking";
import getSupportedLocale from "@irati/utils/lang/helpers/getSupportedLocale";
import storage from "../../helpers/storage";
import defaultAuth from "../../helpers/defaultAuth";
import { LOGIN, AUTH_UPDATE, LOGOUT } from "../actions/AuthActions";
var DEFAULT_STATE = function () {
    var defaultState = storage.get("auth") || {};
    return updateAuth(defaultAuth, defaultState);
};
var AuthenticationReducer = function (state, action) {
    if (state === void 0) { state = DEFAULT_STATE(); }
    var _a = action.auth, auth = _a === void 0 ? {} : _a;
    fixLocale(state, auth);
    switch (action.type) {
        case REHYDRATE:
            return rehydrate(state, action);
        case LOGIN:
            return login(state, auth);
        case AUTH_UPDATE:
            return updateAuth(state, auth);
        case LOGOUT:
            apolloClient.resetStore();
            return logout(auth);
        default:
            return state;
    }
};
export default AuthenticationReducer;
function login(state, data) {
    // merge login data into the defaultAuth data structure
    var auth = merge({}, defaultAuth, state, data);
    storage.set("auth", auth);
    tracking.trackUserLogin(auth.user, auth.userTenant);
    return auth;
}
function updateAuth(state, newState) {
    var cloned = cloneDeep(state);
    Object.keys(newState).forEach(function (key) {
        // defensively only want state that has changed
        if (newState[key]) {
            cloned[key] = newState[key];
        }
    });
    storage.set("auth", cloned);
    return cloned;
}
function logout(auth) {
    storage.clear("auth");
    var cloned = updateAuth(defaultAuth, auth);
    storage.set("auth", cloned);
    return cloned;
}
/** @author: Richard Scoones 24/8/18
 *  @desc: In the app we persist the tenant. On major changes we can get corrupt or missing data. Make sure we inherit from defaultAuth.
 */
function rehydrate(state, action) {
    var auth = action.payload.auth;
    var persistedTenant = get(auth, "userTenant") || {};
    var userTenant = merge({}, defaultAuth.userTenant, persistedTenant);
    var restoredState = __assign(__assign(__assign({}, state), auth), { userTenant: userTenant });
    fixLocale(restoredState);
    return restoredState;
}
/**
 *  @author: Richard
 *  @desc: Fed up fixing this same bug, forcing all locales to be parsed to correct format
 */
function fixLocale(state, auth) {
    var _a, _b;
    var tenant = ((_a = auth) === null || _a === void 0 ? void 0 : _a.userTenant) || state.userTenant;
    var user = ((_b = auth) === null || _b === void 0 ? void 0 : _b.user) || state.user;
    if (tenant && tenant.settings) {
        tenant.locale = getSupportedLocale(tenant.locale);
    }
    if (user) {
        var fallback = tenant.locale;
        user.locale = getSupportedLocale(user.locale || fallback);
    }
}
